import { CheckCircle2, ShieldCheck, Sparkles } from 'lucide-react'
import type { MatchLevel, VerificationLevel } from '../../types/domain'

export function Badge({ children, tone = 'neutral', icon }: { children: React.ReactNode; tone?: 'neutral' | 'blue' | 'cyan' | 'orange' | 'green' | 'red' | 'navy'; icon?: React.ReactNode }) {
  return <span className={`badge badge--${tone}`}>{icon}{children}</span>
}

export function VerificationBadge({ level, compact = false }: { level: VerificationLevel; compact?: boolean }) {
  const labels: Record<VerificationLevel, string> = {
    profile_completed: 'Profil complété', identity_verified: 'Identité vérifiée', sport_verified: 'Parcours vérifié', athlink_verified: 'Profil AthLink vérifié',
  }
  const tone = level === 'athlink_verified' ? 'cyan' : level === 'sport_verified' ? 'blue' : 'neutral'
  return <Badge tone={tone} icon={level === 'athlink_verified' ? <ShieldCheck size={14} /> : <CheckCircle2 size={14} />}>{compact ? labels[level].replace('Profil ', '') : labels[level]}</Badge>
}

export function MatchBadge({ score, level, compact = false }: { score: number; level: MatchLevel; compact?: boolean }) {
  const label = level === 'excellent' ? 'Excellent match' : level === 'good' ? 'Bon potentiel' : 'À explorer'
  return <span className={`match-badge match-badge--${level}`} title={label}><Sparkles size={14} /> <strong>{score} %</strong>{!compact && <span>{label}</span>}</span>
}
